import React from "react";
import { notify } from "@/shared/utils/notify";
import { accompanimentsService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const useCreateAccompaniment = ({
  setOpenModalCreate,
}: {
  setOpenModalCreate: (val: boolean) => void;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    watch,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(yup.object({})),
  });

  const handleSubmit = onSubmit(async (data: any) => {
    if (loading) return;
    setLoading(true);
    await accompanimentsService
      .create({ ...data })
      .then((_res: any) => {
        notify.success(`Se ha creado el acompañamiento ${data.name} exitosamente`);
        setOpenModalCreate(false);
        reset({});
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      })
      .finally(() => {
        setLoading(false);
      });
  });

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
